import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import PackageComponent from './PackageComponent';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import { getMembers, getMember } from '../members/members.actions';
import { createPackage, getPackages, updatePackage, deletePackage } from './Actions';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    toDashboard: () => dispatch(push(paths.dashboard)),
    getMember: (memberId: number) => dispatch(getMember(memberId)),
    getMembers: () => dispatch(getMembers()),
    createPackage: (
      id: number, 
      description: string, 
      memberId: number,
      purchaseDate: number,
      expiryDate: number,
      totalClasses: number,
      paymentId?: number
    ) => dispatch(createPackage(
      id, 
      description, 
      memberId,
      purchaseDate,
      expiryDate,
      totalClasses,
      paymentId
    )),
    deletePackage: (id: number) => dispatch(deletePackage(id)),
    updatePackage: (
      id: number, 
      description: string, 
      memberId: number,
      purchaseDate: number,
      expiryDate: number,
      totalClasses: number,
      paymentId?: number
    ) => dispatch(updatePackage(
      id, 
      description, 
      memberId,
      purchaseDate,
      expiryDate,
      totalClasses,
      paymentId
    )),
    getPackages: () => dispatch(getPackages())
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    idleState: state.idleState,
    membersState: state.membersState,
    programsState: state.programsState,
    businessState: state.businessState,
    packageState: state.packageState
  };
};

const Package = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PackageComponent);

export default Package;



// WEBPACK FOOTER //
// ./src/mms-package/Package.tsx